import {PROFILE_FIELD_NAMES} from "./ProfileEnum";

export const ProfileMinMax = {
  [PROFILE_FIELD_NAMES.DOB]: {
    min: 21,
    max: 60,
  },
  [PROFILE_FIELD_NAMES.RES_TENURE]: {
    min: 0,
    max: 60,
  },
  [PROFILE_FIELD_NAMES.WORKING_SINCE]: {
    min: 0,
    max: 60,
  }
};
